export default "__VITE_ASSET__DNwu5DMR__"